const APP_BASE_PATH = '/sell-my-car';
const OLD_APP_BASE_PATH = '/sellyourcar';

export { APP_BASE_PATH, OLD_APP_BASE_PATH };
